export default "__VITE_PUBLIC_ASSET__9f6e84a1__"